/**
 * 路由组件出口文件
 */
import AdminPage from '../pages/admin/AdminPage';
import AdminManagerPage from '../pages/admin/AdminManagerPage'; 
import CustomerPage from '../pages/customer/CustomerPage';
import CustomerContactManagerPage from '../pages/customer/CustomerManagerPage';
import CompanyPage from '../pages/company/CompanyPage';
import CompanyManagerPage from '../pages/company/CompanyManagerPage';
import ContactPage from '../pages/contact/ContactPage';
import ContactManagerPage from '../pages/contact/ContactManagerPage';
import MyContactPage from '../pages/contact/MyContactPage';
import RequirementPage from '../pages/requirement/RequirementPage';
import RequirementManagerPage from '../pages/requirement/RequirementManagerPage';
import FileManagerPage from '../pages/file/FileManagerPage';
import CustomerManagerListPage from '../pages/customerManager/CustomerManagerPage';
import CustomerManagerManagerPage from '../pages/customerManager/CustomerManagerManagerPage';
import ConsultantPage from '../pages/consultant/ConsultantPage';
import ConsultantManagerPage from '../pages/consultant/ConsultantManagerPage';
import ProjectPage from '../pages/project/ProjectPage';
import ProjectManagerPage from '../pages/project/ProjectManagerPage';
import PromptVersionPage from '../pages/settings/PromptVersionPage';
import PromptFeedbackPage from '../pages/settings/PromptFeedbackPage';
import WorkbenchPage from '../pages/workbench/WorkbenchPage';
import TasksPage from '../pages/workbench/TasksPage';
import CompaniesPage from '../pages/customer/CompaniesPage';
import PersonsPage from '../pages/customer/PersonsPage';
import CommunicationsPage from '../pages/customer/CommunicationsPage';
import SignalsPage from '../pages/development/SignalsPage';
import OpportunityPage from '../pages/opportunity/OpportunityPage';
import ProjectV2Page from '../pages/projectV2/ProjectV2Page';
import AnalyticsPage from '../pages/analytics/AnalyticsPage';
import AuditEventsPage from '../pages/settings/AuditEventsPage';
import EmailTemplatesPage from '../pages/mail/EmailTemplatesPage';
import RecipientListsPage from '../pages/mail/RecipientListsPage';
import MailBatchesPage from '../pages/mail/MailBatchesPage';
import InboundMonitorPage from '../pages/mail/InboundMonitorPage';
import MailAccountsPage from '../pages/mail/MailAccountsPage';
import MailDispatchOperationsPage from '../pages/mail/MailDispatchOperationsPage';
import { DevelopmentOverviewPage, ResourceOverviewPage, SettingsOverviewPage } from '../pages/v2/AvailabilityPages';

import Loadable from 'react-loadable';
import Loading from './widget/Loading';
import BasicTable from './tables/BasicTables';
import AdvancedTable from './tables/AdvancedTables';
import AsynchronousTable from './tables/AsynchronousTable';
import Echarts from './charts/Echarts';
import Recharts from './charts/Recharts';
import Icons from './ui/Icons';
import Buttons from './ui/Buttons';
import Spins from './ui/Spins';
import Modals from './ui/Modals';
import Notifications from './ui/Notifications';
import Tabs from './ui/Tabs';
import Banners from './ui/banners';
import Drags from './ui/Draggable';
import Dashboard from './dashboard/Dashboard';
import Gallery from './ui/Gallery';
import BasicAnimations from './animation/BasicAnimations';
import ExampleAnimations from './animation/ExampleAnimations';
import AuthBasic from './auth/Basic';
import RouterEnter from './auth/RouterEnter';
import Cssmodule from './cssmodule';
import MapUi from './ui/map';
import QueryParams from './extension/QueryParams';
import Visitor from './extension/Visitor';
import MultipleMenu from './extension/MultipleMenu';
import Sub1 from './smenu/Sub1';
import Sub2 from './smenu/Sub2';
import Env from './env';

const WysiwygBundle = Loadable({
    // 按需加载富文本配置
    loader: () => import('./ui/Wysiwyg'),
    loading: Loading,
});

export default {
    AdminPage,
    AdminManagerPage,
    CustomerPage,
    CustomerManagerPage: CustomerContactManagerPage,
    CompanyPage,
    CompanyManagerPage,
    ContactPage,
    ContactManagerPage,
    MyContactPage,
    RequirementPage,
    RequirementManagerPage,
    FileManagerPage,
    CustomerManagerListPage,
    CustomerManagerManagerPage,
    ConsultantPage,
    ConsultantManagerPage,
    ProjectPage,
    ProjectManagerPage,
    PromptVersionPage,
    PromptFeedbackPage,
    WorkbenchPage,
    TasksPage,
    CompaniesPage,
    PersonsPage,
    CommunicationsPage,
    SignalsPage,
    OpportunityPage,
    ProjectV2Page,
    AnalyticsPage,
    AuditEventsPage,
    EmailTemplatesPage,
    RecipientListsPage,
    MailBatchesPage,
    InboundMonitorPage,
    MailAccountsPage,
    MailDispatchOperationsPage,
    DevelopmentOverviewPage,
    ResourceOverviewPage,
    SettingsOverviewPage,

    BasicTable,
    AdvancedTable,
    AsynchronousTable,
    Echarts,
    Recharts,
    Icons,
    Buttons,
    Spins,
    Modals,
    Notifications,
    Tabs,
    Banners,
    Drags,
    Dashboard,
    Gallery,
    BasicAnimations,
    ExampleAnimations,
    AuthBasic,
    RouterEnter,
    WysiwygBundle,
    Cssmodule,
    MapUi,
    QueryParams,
    Visitor,
    MultipleMenu,
    Sub1,
    Sub2,
    Env,
} as any;
